<template>
  <div id="hr_settings" class="flex flex-col gap-10 proxima_nova">
    <h1 class="text-xl font-semibold text_color">HR</h1>

    <div id="objects_section" class="flex flex-col gap-4">
      <h2 class="text-lg font-semibold text_color">Objects</h2>
      <div v-if="objectsLoading" class="flex justify-center py-8">
        <a-spin />
      </div>
      <SimpleTable
        v-else
        :headers="objectHeaders"
        :data="objectsData"
        :show-actions-column="false"
        :custom-column-render="objectColumnRender"
        :custom-row="objectCustomRow"
        :force-x-virtual="false"
        :auto-height="false"
        :table-props="{ virtual: false }"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, h } from "vue";
import { useRouter } from "vue-router";
import HRService from "@/src/api/HRService.js";
import SimpleTable from "@/src/components/custom_table_components/SimpleTable.vue";

const router = useRouter();
const objectsLoading = ref(true);
const objects = ref([]);

const objectHeaders = [
  { key: "name", title: "Object", width: 250 },
  { key: "apps", title: "App", width: 400 },
];

const AppBadges = (props) => {
  const apps = props.value || [];
  return h("div", { class: "flex flex-wrap gap-1" },
    apps.map((app) =>
      h("span", {
        class: "px-2 py-[2px] text-xs rounded secondary_color",
        style: "border: 1px solid var(--white-opacity-10); background: var(--white-opacity-4);",
      }, app)
    )
  );
};

const objectColumnRender = {
  apps: {
    component: AppBadges,
    props: (record) => ({ value: record.apps }),
  },
};

const objectCustomRow = (record) => ({
  style: "cursor: pointer;",
  onClick: () => router.push(`/people/hidden/${record.slug}`),
});

const objectsData = computed(() => objects.value);

const fetchObjects = async () => {
  objectsLoading.value = true;
  try {
    const response = await HRService.hr.listObjects();
    if (response?.data?.objects) {
      objects.value = response.data.objects;
    }
  } catch (error) {
    console.error("An error occurred while fetching HR objects: ", error);
  } finally {
    objectsLoading.value = false;
  }
};

onMounted(async () => {
  await fetchObjects();
});
</script>
